export default __webpack_public_path__ + "fae3ab81f1acdeecc0bf3a69e35f9cd7.png";